import { TierRule } from './tier-rule';
export class Tier
{
	id: number;
	name: string;
	tierRules: TierRule[];

	constructor()
	{
		this.tierRules = [];
	}
}



// WEBPACK FOOTER //
// ./src/app/models/tier.ts